export enum LAYOUT_COLOR_TYPES {
  LIGHTMODE = 'light',
  DARKMODE = 'dark',
}

export enum SIDEBAR_SIZE_TYPES {
  DEFAULT = 'default',
  COLLAPSED = 'collapsed',
}

export enum STARTBAR_COLOR_TYPE {
  LIGHT = 'light',
  DARK = 'dark',
}
